import React from "react";

const ACT_LABELS_BASE = {
  MISSION: "Worked",
  CONGE: "Paid leave",
  MALADIE: "Sick leave",
  INJUSTIFIE: "Unjustified",
  FORMATION: "Training",
  DAILY: "Daily",
};
const ACT_COLORS = {
  MISSION: "bg-emerald-100 text-emerald-800",
  CONGE: "bg-sky-100 text-sky-800",
  MALADIE: "bg-rose-100 text-rose-800",
  INJUSTIFIE: "bg-amber-100 text-amber-800",
  FORMATION: "bg-violet-100 text-violet-800",
  DAILY: "bg-zinc-100 text-zinc-700",
};
const ORDER_FREELANCE = ["MISSION", "CONGE"];
const ORDER_EMPLOYEE = ["MISSION", "CONGE", "MALADIE", "INJUSTIFIE", "FORMATION", "DAILY"];

/**
 * Iter-79: month-to-date summary banner.
 *
 * @param {Object} props.activityMonthDays  Days-this-month per activity_type
 * @param {number} props.workingDaysInMonth Working days target (Mon..Fri minus holidays)
 * @param {boolean} props.isFreelance       Affects label + which buckets to show
 */
export default function MonthSummaryBanner({ activityMonthDays, workingDaysInMonth, isFreelance }) {
  const ACT_LABELS = { ...ACT_LABELS_BASE, CONGE: isFreelance ? "Leave" : "Paid leave" };
  const order = isFreelance ? ORDER_FREELANCE : ORDER_EMPLOYEE;
  const worked = activityMonthDays.MISSION || 0;
  const target = workingDaysInMonth || 0;
  const ratio = target > 0 ? worked / target : 0;
  const workedTone = worked === 0
    ? "bg-zinc-100 text-zinc-600"
    : ratio >= 1
      ? "bg-emerald-100 text-emerald-800 ring-1 ring-emerald-300"
      : ratio >= 0.5
        ? "bg-emerald-50 text-emerald-700"
        : "bg-amber-50 text-amber-800";
  return (
    <div
      data-testid="month-summary-banner"
      className="mb-3 flex flex-wrap items-center gap-2 px-4 py-2 rounded-lg border border-zinc-200 bg-zinc-50/60"
    >
      <span
        data-testid="month-summary-worked"
        className={`px-2.5 py-1 rounded-md text-xs font-mono font-semibold ${workedTone}`}
        title="Jours imputés sur missions / jours ouvrés du mois"
      >
        Worked {worked.toLocaleString(undefined, { maximumFractionDigits: 2 })} / {target} j
      </span>
      {order.filter((k) => k !== "MISSION").map((k) => {
        const v = activityMonthDays[k] || 0;
        if (v === 0) return null;
        return (
          <span
            key={k}
            data-testid={`month-summary-${k.toLowerCase()}`}
            className={`px-2.5 py-1 rounded-md text-xs font-mono ${ACT_COLORS[k] || "bg-zinc-100 text-zinc-700"}`}
          >
            {ACT_LABELS[k] || k} {v.toLocaleString(undefined, { maximumFractionDigits: 2 })} j
          </span>
        );
      })}
    </div>
  );
}
